export enum ITicketingType {
  None = 'None',
  Integrated = 'Integrated',
  Onboard = 'Onboard',
  Online = 'Online',
  Hybrid = 'Hybrid',
  Periodically = 'Periodically',
}
